<template>
  <div id="app">
    <!-- 主要内容区域 -->
    <router-view />
  </div>
</template>

<script>
import { ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'

export default {
  name: 'App',
  setup() {
    const { locale } = useI18n()
    const currentLanguage = ref('en')

    const changeLanguage = (lang) => {
      locale.value = lang
      currentLanguage.value = lang
      localStorage.setItem('language', lang)
    }

    onMounted(() => {
      const savedLang = localStorage.getItem('language') || 'en'
      currentLanguage.value = savedLang
      locale.value = savedLang
    })

    return {
      currentLanguage,
      changeLanguage
    }
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
body {
  font: 12px/1.5 \5fae\8f6f\96c5\9ed1, \5b8b\4f53, Hiragino Sans GB, STHeiti, WenQuanYi Micro Hei, Droid Sans Fallback, PingFangSC-Semibold, SimSun, sans-serif;
}
</style>
